import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'analytics/:imagename',
  // onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PlaceholderContainer = require('./containers/Placeholder').default
      // const reducer = require('./modules/report').default

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })

      /*  Return getComponent   */
      cb(null, PlaceholderContainer)

    /* Webpack named bundle   */
    }, 'placeholder')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Placeholder/index.js